/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { Auth } from "aws-amplify";
import { useNavigate, useLocation } from "react-router-dom";

export default function RoleGuard({ children }) {

    const navigate = useNavigate();
    const location = useLocation();

    const redirectToLogin = () => {
        const redirectUrl = `${location.pathname}${location.search}`;
        localStorage.setItem("redirectUrl", redirectUrl);
        localStorage?.removeItem("accessToken");
        localStorage?.removeItem("idToken");
        navigate("/");
    }

    useEffect(() => {
        Auth.currentSession()
            .then((session) => {
                const isValid = session?.isValid();
                if (!isValid) {
                    redirectToLogin();
                }
            })
            .catch(() => {
                redirectToLogin();
            });
    }, [location]);

    return <>{children}</>
}